<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('c2c.bt2')}}</div>
        </div>
        <div class="cotainer">
          <div class="item-head">
            <div class="title">
              {{$t('c2c.mblc')}}
              <img class="kf" @click="link" src="@/assets/new3/kefu2.png" alt="">
            </div>
            <ul class="step-box">
              <li class="step">{{$t('c2c.cjydd')}}</li>
              <li class="step step2">{{$t('c2c.lxkfppdd')}}</li>
              <li class="step">{{$t('c2c.tjpz')}}</li>
            </ul>
          </div>
          <div class="box">
            <ul class="tab-ul">
              <li class="tab" @click="jump(1)">{{$t('c2c.cjdd')}}</li>
              <li class="tab" @click="jump(2)">{{$t('c2c.tjpz')}}</li>
            </ul>
            <div class="tips">{{$t('c2c.wdys')}}</div>
            <ul class="item-box">
              <li class="item-li">
                <img class="icon" src="@/assets/new2/dijia.png" alt="">
                <div>
                  <div class="t1">{{$t('c2c.c1')}}</div>
                  <div class="t2">{{$t('c2c.c2')}}</div>
                </div>
              </li>
              <li class="item-li">
                <img class="icon" src="@/assets/new2/zhifufangshi.png" alt="">
                <div>
                  <div class="t1">{{$t('c2c.c3')}}</div>
                  <div class="t2">{{$t('c2c.c4')}}</div>
                </div>
              </li>
              <li class="item-li">
                <img class="icon" src="@/assets/new2/jiagezoushi.png" alt="">
                <div>
                  <div class="t1">{{$t('c2c.c5')}}</div>
                  <div class="t2">{{$t('c2c.c6')}}</div>
                </div>
              </li>
            </ul>
            <div class="tips">{{$t('c2c.jcwdwt')}}</div>
            <div class="cont" v-html="cont"></div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'c2c',
    data () {
        return {
          token: '',
          cont: ''
        }
    },
    created(){
      this.token = localStorage.getItem('token') || '';
    },
    mounted() {
      this.getList()
    },
    methods: {
      back(){
        this.$router.push('/index')
      },
      link(){
        this.$router.push('/onlineService')
      },
      jump(id){
        if(id == 1){
          this.$router.push('/c2cCreate')
        }else if(id == 2){
          this.$router.push('/c2cCredentials')
        }
      },
      getList(){
        let params = {
            type: 'recharge'
        }
        this.$ajax.get('/web/getTextsList',{params}).then((res) => {
            let resData = res.data.data;
            this.cont = this.contHtml(resData.content);
        }).catch(function(err){
            console.log(err)
        })
      },
      contHtml(str){
        str = str.replace(/&amp;/g, '&');
        str = str.replace(/&lt;/g, '<');
        str = str.replace(/&gt;/g, '>');
        str = str.replace(/&quot;/g, "''");
        str = str.replace(/&#039;/g, "'");
        return str;
      },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
  .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.2rem;
        padding: 0 .3rem;
        color: #fff;
        line-height: 1.2rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .3rem;
        margin-top: -.3rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.2rem;
        bottom: 0;
        width: 100%;
        background: transparent;
        overflow-y: scroll;
    }
    .item-head{
      position: relative;
      height: 4.92rem;
      padding: .48rem .48rem .6rem;
      background: url(../assets/new2/M8.png) no-repeat center center;
      background-size: 100% 100%;
      box-sizing: border-box;
    }
    .item-head .title{
      position: relative;
      color: #fff;
      font-size: .56rem;
    }
    .item-head .title .kf{
      position: absolute;
      right: 0;
      top: 0;
      width: .68rem;
    }
    .item-head .step-box{
      position: absolute;
      left: .48rem;
      right: .48rem;
      bottom: .1rem;
      display: flex;
      justify-content: center;
    }
    .item-head .step-box .step{
      width: 30%;
      color: #fff;
      font-size: .36rem;
      text-align: center;
    }
    .item-head .step-box .step.step2{
      width: 40%;
    }
    .box{
      padding: .84rem .34rem .7rem;
      background-color: #11133d;
	    border-radius: 0.5rem;
    }
    .box .tab-ul{
      display: flex;
      align-items: center;
      margin: 0 .15rem 0;
    }
    .box .tab-ul .tab{
      width: 50%;
      height: 1.1rem;
      color: #fff;
      font-size: .48rem;
      line-height: 1.1rem;
      background-color: #0060ff;
      border-radius: 0.2rem;
      text-align: center;
    }
    .box .tab-ul .tab:first-child{
      margin-right: .4rem;
    }
    .box .tips{
      padding: .8rem 0 .6rem;
      color: #fff;
      font-size: .48rem;
    }
    .box .item-li{
      display: flex;
      align-items: center;
      margin-bottom: .5rem;
      background-color: #0e0f31;
      padding: .5rem .6rem .5rem .6rem;
	    border-radius: 0.15rem;
    }
    .box .item-li .icon{
      width: 1.32rem;
      margin-right: .5rem;
    }
    .box .item-li .t1{
      color: #fff;
      font-size: .42rem;
    }
    .box .item-li .t2{
      padding-top: .4rem;
      color: #fff;
      font-size: .34rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/c2c.vue